import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Sprout } from "lucide-react";

const LINKS = [
  { href: "/#ecosistema", label: "Ecosistema" },
  { href: "/#servicios", label: "Servicios" },
  { href: "/#metodo", label: "Método NODO" },
  { href: "/#formacion", label: "Formación" },
  { href: "/#biblioteca", label: "Biblioteca" },
  { href: "/tablero", label: "Tablero", route: true },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href, route) => {
    setOpen(false);
    if (route) navigate(href);
    else window.location.href = href;
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-rc-bg/85 border-b border-rc-border" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <Sprout className="w-5 h-5 text-rc-sage" strokeWidth={1.6} />
          <span className="font-serif text-lg text-stone-100 tracking-tight">
            Raíz<span className="text-rc-sage"> Commerce</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href, l.route)}
              className="text-sm text-stone-400 hover:text-rc-sage transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-diagnostico-cta"
            onClick={() => go("/#contacto")}
            className="text-sm px-5 py-2 rounded-full bg-rc-forest hover:bg-rc-forestlight text-stone-100 transition-colors"
          >
            Agenda tu diagnóstico
          </button>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="text-xs text-stone-600 hover:text-stone-400 transition-colors font-mono"
          >
            Equipo
          </Link>
        </div>

        <button
          className="lg:hidden text-stone-200"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-rc-bg/95 backdrop-blur-xl border-b border-rc-border px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href, l.route)}
              className="text-left text-stone-300 hover:text-rc-sage transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-diagnostico-cta"
            onClick={() => go("/#contacto")}
            className="text-sm px-5 py-2.5 rounded-full bg-rc-forest text-stone-100 text-center"
          >
            Agenda tu diagnóstico
          </button>
          <Link to="/admin" className="text-xs text-stone-500 font-mono" onClick={() => setOpen(false)}>
            Acceso equipo
          </Link>
        </div>
      )}
    </header>
  );
};
